import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user, loading, checked, checkAuth } = useAuth();

  useEffect(() => {
    // Handles client-side navigation into /admin from a public page (session never verified)
    if (!loading && !user && !checked) checkAuth();
  }, [loading, user, checked, checkAuth]);

  if (loading || (!user && !checked)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <Loader2 className="w-8 h-8 animate-spin text-navy" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
